import { render, staticRenderFns } from "./SpaceOverview.vue?vue&type=template&id=5a5a6d89&scoped=true&"
import script from "./SpaceOverview.vue?vue&type=script&lang=ts&"
export * from "./SpaceOverview.vue?vue&type=script&lang=ts&"
import style0 from "./SpaceOverview.vue?vue&type=style&index=0&id=5a5a6d89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5a6d89",
  null
  
)

export default component.exports